import { createContext, useContext } from "react";
export const ProductsProducerContext = createContext(undefined);
const NOOP = () => { };
/** @internal The publish function, or a no-op if there's no `<ArtisAppProvider>` above. */
export const useProductsProducer = () => useContext(ProductsProducerContext) ?? NOOP;
//# sourceMappingURL=productsProducer.js.map